import locale from 'date-fns/locale/en-GB';
import { setDefaultLocale } from '@lingoda/dates';
import '@lingoda/translations/en';

setDefaultLocale(locale);
